import { FC, useRef } from "react";
import { MdEdit } from "react-icons/md";
import { UploadImagePresentationProps } from "../../../types/types";
import {
  AdminHexImage,
  ImageUPloadWrapper,
  ImageUploadEditButtton,
  ImageUploadEditButttonIcon,
  ImageUploadEditButttonText,
  LoadingWrapper,
  UploadImageStyle,
  UploadImageStyleShop,
} from "./uploadimage.presentation.styles";

import { images } from "../../../constants";
import Loading from "../../Loading/Loading";
const UPloadImagePresentation: FC<UploadImagePresentationProps> = ({
  imageUrl,
  onChagne,
  shop,
  hexShape,
  loading
}) => {
  const fileRef = useRef<HTMLInputElement>(null)

  return (
    <>
    {loading ? (
     <LoadingWrapper width={'103px'} height={'100px'} >
     <Loading />
     </LoadingWrapper>
    ) : (
      <ImageUPloadWrapper shop>
      {shop
        ? (
        <UploadImageStyleShop src={imageUrl} alt={imageUrl} />
          )
        : (
        <UploadImageStyle src={imageUrl} alt={imageUrl} />
          )}
      {hexShape ? <AdminHexImage src={images.hexAsset} alt="gradegy" /> : null}
      {/* add the accept to limit just image can select */}
      <input
        type="file"
        onChange={onChagne}
        style={{ display: 'none' }}
        ref={fileRef}
        accept="image/*"
      />
      <ImageUploadEditButtton
        type="button"
        onClick={() => {
          if (fileRef.current) {
            fileRef.current.click()
          }
        }}
      >
        <ImageUploadEditButttonText>Edit</ImageUploadEditButttonText>
        <ImageUploadEditButttonIcon>
          <MdEdit color="#34C38F" size={17} />
        </ImageUploadEditButttonIcon>
      </ImageUploadEditButtton>
    </ImageUPloadWrapper>
    ) }

    </>
  )
}

export default UPloadImagePresentation
